import * as React from "react";
const ArrowRight = props => <symbol viewBox="0 0 24 24" {...props}>
    <path d="M5 12.745h12.184l-4.726 4.726a.75.75 0 001.06 1.06l5.994-5.993a.75.75 0 00.238-.543v-.006a.75.75 0 00-.22-.53l-6.012-6.011a.757.757 0 00-.53-.22.757.757 0 00-.53.22c-.14.139-.22.333-.22.53s.08.391.22.53l4.737 4.737H5a.75.75 0 000 1.5z" />
  </symbol>;
export default ArrowRight;